// extracted by mini-css-extract-plugin
export default {"durationText":"style_durationText__U+1cf","rtl":"style_rtl__sO3O6","ltr":"style_ltr__TtFgx","durationPart":"style_durationPart__MpaNn","durationValue":"style_durationValue__E6eMk"};